export const GROUPS_STAGE = [
  "Trial",
  "Onboarding",
  "Nurturing",
  "Active",
  "Risk",
  "Churned",
];
export const GROUPS_ADOPTION = [
  "Stripe",
  "Website",
  "Directory",
  "Stadium",
  "Global",
  "Channels",
];
export const GROUPS_OWNER = ["Abby", "Birdie", "Justin", "Tom"];
export const GROUPS_CHANNEL = ["Email", "Instagram", "Whatsapp", "Twitter"];
export const GROUPS_LEAD_SOURCE = ["Website", "Referral", "Outbound"];
